/*
document.addEventListener("DOMContentLoaded", function() {
      var daysAfterToday = 1; // Set this to the number of days after today that the item will ship
      var today = new Date();
      var shipDate = new Date(today);
      var options = { weekday: 'short', month: 'short', day: 'numeric' };

      // Function to skip Sundays
      function calculateShippingDate(date, daysToAdd) {
          date.setDate(date.getDate() + daysToAdd);

          // If the calculated shipping date is a Sunday, add one more day
          // if (date.getDay() === 5) {
          //     date.setDate(date.getDate() + 3);
          // }
          // If the calculated shipping date is a Sunday, add one more day
          // if (date.getDay() === 6) {
          //     date.setDate(date.getDate() + 2);
          // }
          // If the calculated shipping date is a Sunday, add one more day
          // if (date.getDay() === 0) {
          //     date.setDate(date.getDate() + 1);
          // }

          return date;
      }

      // Calculate the shipping date
      shipDate = calculateShippingDate(shipDate, daysAfterToday);
      var formattedDate = shipDate.toLocaleDateString('en-US', options);

      // Update the shipping date in the HTML
      document.getElementById('shipping-date').textContent = formattedDate;
  });
*/

$(document).ready(function(){
// collection page slick slider
      mobileOnlySlider(".cust_multicolumn .multicolumn_inner", true, false, 768);
        
        function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
        	var slider = $($slidername);
        	var settings = {
        		mobileFirst: true,
        		dots: $dots,
        		arrows: $arrows,
                slidesToShow: 2,
                slidesToScroll: 1,
                autoplay: true,
        		responsive: [
        			{
        				breakpoint: $breakpoint,
        				settings: "unslick"
        			}
        		]
        	};
        
        	slider.slick(settings);
        
        	$(window).on("resize", function () {
        		if ($(window).width() > $breakpoint) {
        			return;
        		}
        		if (!slider.hasClass("slick-initialized")) {
        			return slider.slick(settings);
        		}
        	});
        } // Mobile Only Slider

      // product page collection slider

        var $swiperSelector = $('.custom_collection');
      
      $swiperSelector.each(function(index) {
          var $this = $(this);
          $this.addClass('swiper-slider-' + index);
          
          var dragSize = $this.data('drag-size') ? $this.data('drag-size') : 50;
          var freeMode = $this.data('free-mode') ? $this.data('free-mode') : false;
          var loop = $this.data('loop') ? $this.data('loop') : false;
          var slidesDesktop = $this.data('slides-desktop') ? $this.data('slides-desktop') : 4;
          var slidesTablet = $this.data('slides-tablet') ? $this.data('slides-tablet') : 2;
          var slidesMobile = $this.data('slides-mobile') ? $this.data('slides-mobile') : 1.5;
          var spaceBetween = $this.data('space-between') ? $this.data('space-between'): 0;
      
          var swiper = new Swiper('.swiper-slider-' + index, {
            
            loop: loop,
            freeMode: freeMode,
            spaceBetween: spaceBetween,            
            effect: "coverflow",
            centeredSlides: true,
            slidesPerView: "auto",
              loopAdditionalSlides: 4,
              loopedSlides: 4,
              loop: true,
              coverflowEffect: {
                  rotate: 0,
                  stretch: 0,
                  depth: 200,
                  modifier: 1,
                  slideShadows: false
                },
            
            breakpoints: {
              1920: {
                slidesPerView: slidesDesktop,
                loop: true,                  
              },
              1024:{
                slidesPerView: 4,
              },
              992: {
                slidesPerView: slidesTablet,                
              },
               767: {
                slidesPerView: slidesTablet,                
                spaceBetween: 0,
              },
              320: {
                 slidesPerView: slidesMobile
              }
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            },
            scrollbar: {
              el: '.swiper-scrollbar',
              draggable: true,
              dragSize: dragSize
            }
         });
      });

  setTimeout(function(){
  var copysizeChart = $(".rev_tab .ks-chart-container .ks-table-content-wrapper").html();
    if($('.rev_tab').find('.ks-chart-container').length !== 0){        
        $(".custom_size_chart_popup #cust_pop_body").html(copysizeChart);
      }
      else
      {
        $('.prod_size_chrt').css('display','none');
        $('.var_size').css('display','none');        
      }
    },1000)
  // show hide size chart
    $(document).on("click", ".var_size", function(){
      $(".custom_size_chart_popup").fadeIn("slow");      
  })
   $(document).on("click", ".custom_size_chart_popup_overlay, .custom_size_chart_popup span.size_close", function(){
      $(".custom_size_chart_popup").fadeOut("slow");      
  })

  // add next day date in product page
    var date = new Date();
    var addDay = 1;
    var monthss=["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"];
    var formatted = new Date(date.setDate(date.getDate() + addDay));
    var value = formatted.getDate()+ " " + monthss[date.getMonth()];
    $("#sale_tom_date").text(value)	;
  
}); // end cocument ready